import { Routes } from '@angular/router';
import { rootGuard } from './core/admin.guard';
import { AdminLayoutComponent } from './layouts/admin-layout.component';
import { AdminUsersComponent } from './pages/admin-users.component';
import { DeletionRecordsComponent } from './pages/deletion-records.component';
import { GameDetailComponent } from './pages/game-detail.component';
import { GamesComponent } from './pages/games.component';
import { UnauthorizedComponent } from './pages/unauthorized.component';

export const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'games' },
      { path: 'games', component: GamesComponent, title: '活動管理｜CrewJam 後台' },
      { path: 'games/:id', component: GameDetailComponent, title: '活動詳細｜CrewJam 後台' },
      { path: 'deletion-records', component: DeletionRecordsComponent, title: '刪除紀錄｜CrewJam 後台' },
      { path: 'admin-users', component: AdminUsersComponent, canActivate: [rootGuard], title: '管理者白名單｜CrewJam 後台' },
      { path: 'unauthorized', component: UnauthorizedComponent, title: '無存取權限｜CrewJam 後台' },
    ],
  },
  { path: '**', redirectTo: 'games' },
];
